import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function FadeIn({ children, className }) {
  const ref = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`fade-in ${className || ''}`}>{children}</div>;
}

function Home() {
  return (
    <>
      <section className="hero" style={{ backgroundImage: 'url(/images/hero.jpg)' }}>
        <div className="hero-overlay">
          <h1>Capturing Your Moments</h1>
          <p>Event Photography · Graphics Design · Austin, TX</p>
          <Link to="/gallery" className="cta-btn">View Gallery</Link>
        </div>
      </section>

      <section className="section intro">
        <FadeIn>
          <h2>Welcome</h2>
          <p>
            Located in the greater Austin, TX area, we specialize in event photography — from
            concerts to family gatherings. We have experience shooting in a variety of situations
            and we're ready to help you capture your important moments.
          </p>
        </FadeIn>
      </section>

      <section className="section preview-gallery">
        <FadeIn>
          <h2>Recent Work</h2>
          <div className="preview-grid">
            {[
              { src: '/images/hero.jpg', alt: 'Event photography' },
              { src: '/images/gallery1.jpg', alt: 'Portrait work' },
              { src: '/images/gallery2.jpg', alt: 'Photography' },
            ].map((img, i) => (
              <div key={i} className="preview-item">
                <img src={img.src} alt={img.alt} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="center-link">
            <Link to="/gallery" className="cta-btn">See Full Gallery</Link>
          </div>
        </FadeIn>
      </section>

      <section className="section services">
        <FadeIn>
          <h2>Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <span className="service-icon">📸</span>
              <h3>Event Photography</h3>
              <p>Concerts, family gatherings, corporate events, and more.</p>
            </div>
            <div className="service-card">
              <span className="service-icon">🎨</span>
              <h3>Graphics Design</h3>
              <p>Brochures, newsletters, business cards, invitations, and branding.</p>
            </div>
            <div className="service-card">
              <span className="service-icon">🌐</span>
              <h3>Web Design</h3>
              <p>Professional websites with managed content systems, ready in days.</p>
            </div>
          </div>
        </FadeIn>
      </section>

      <section className="section cta-section">
        <FadeIn>
          <h2>Let's Work Together</h2>
          <p>Whether you need photography, design, or web services, we'd love to hear from you.</p>
          <a href="mailto:robert.higareda@gmail.com" className="cta-btn">Contact Us</a>
        </FadeIn>
      </section>
    </>
  );
}

export default Home;
